import { render } from "./adminAppointmentView.vue?vue&type=template&id=6f54760d&scoped=true"
import script from "./adminAppointmentView.vue?vue&type=script&lang=js"
export * from "./adminAppointmentView.vue?vue&type=script&lang=js"

import "./adminAppointmentView.vue?vue&type=style&index=0&id=6f54760d&scoped=true&lang=css"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6f54760d"]])

export default __exports__